import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-prompt-message',
    templateUrl: './prompt-message.component.html',
    styleUrls: ['./prompt-message.component.scss'],
    standalone: false
})
export class PromptMessageComponent implements OnInit, OnChanges {
  @Input() showForm: boolean;
  @Input() color: string; // Success, Primary or Danger...
  @Input() message: string;
  @Input() title = '';
  @Input() actionLabel = '';
  @Output() onAction = new EventEmitter<void>();
  @Output() onClose = new EventEmitter();
  formattedMessage = '';
  constructor(public globalService: GlobalService) {}

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges(): void {
    this.formattedMessage = (this.message || '').replace(/\\n/g, '<br>');
  }

  Close() {
    this.showForm = false;
    this.onClose.emit();
  }
}
